import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryEvaluationAnalysis } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '550px'
    },
    height: {
      type: String,
      default: '350px'
    },
    top: {
      type: String,
      default: '75px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '30px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    type: {},
    id: {},
    selectType: {}
  },
  data: function data() {
    return {
      chart: 'pieChart'
    };
  },
  watch: {
    id: {
      handler: function handler(val) {// this.getData(this.type, val, 3, this.selectType)
      },
      immediate: true
    }
  },
  mounted: function mounted() {// this.initBarChart()
  },
  methods: {
    initBarChart: function initBarChart() {
      var ydata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var color = ["#18b4d2", "#1780AC", "#e75fc3", "#f87be2", "#f2719a", "#fca4bb", "#f59a8f", "#fdb301", "#57e7ec", "#cf9ef1"];
      var xdata = [];
      ydata.forEach(function (item) {
        xdata.push(item.name);
      });
      var option = {
        color: color,
        // legend: {
        //   orient: "vartical",
        //   x: "left",
        //   top: "center",
        //   left: "60%",
        //   bottom: "0%",
        //   data: xdata,
        //   itemWidth: 8,
        //   itemHeight: 8,
        //   itemGap: 16,
        //   textStyle:{
        //     color:'#fff'
        //   },

        /*formatter:function(name){
            var oa = option.series[0].data;
            var num = oa[0].value + oa[1].value + oa[2].value + oa[3].value+oa[4].value + oa[5].value + oa[6].value + oa[7].value+oa[8].value + oa[9].value ;
            for(var i = 0; i < option.series[0].data.length; i++){
                  if(name==oa[i].name){
                    return ' '+name + '    |    ' + oa[i].value + '    |    ' + (oa[i].value/num * 100).toFixed(2) + '%';
                  }
            }
          }*/
        //   formatter: function (name) {
        //     return "" + name;
        //   },
        // },
        series: [{
          type: "pie",
          clockwise: false,
          //饼图的扇区是否是顺时针排布
          minAngle: 2,
          //最小的扇区角度（0 ~ 360）
          radius: ["35%", "65%"],
          center: ["40%", "50%"],
          avoidLabelOverlap: false,
          itemStyle: {
            //图形样式
            normal: {
              borderColor: "#ffffff",
              borderWidth: 3
            }
          },
          label: {
            normal: {
              show: true,
              position: "inside",
              formatter: "{text|{b}}\n{c} 个",
              rich: {
                text: {
                  color: "#fff",
                  fontSize: 14,
                  align: "center",
                  verticalAlign: "middle",
                  padding: 8
                },
                value: {
                  color: "#8693F3",
                  fontSize: 14,
                  align: "center",
                  verticalAlign: "middle"
                }
              }
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: 20
              }
            }
          },
          data: ydata
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    }
  }
};